<h2 mat-dialog-title>Adding currency</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>Enter the currency code</mat-label>
    <input
      matInput
      [(ngModel)]="data.name"
      (input)="onInputChange($event)"
      maxlength="3"
      minlength="3"
      name="currencyCode"
      #currencyCode="ngModel"
      required
    />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button
    mat-button
    cdkFocusInitial
    (click)="onAddClick()"
    [disabled]="!data.name || currencyCode.invalid || data.name.length < 3"
  >
    Add
  </button>
</mat-dialog-actions>

